import { useMutation } from 'react-query';

import { removeCard as mutationFn } from 'api/endPoints/removeCard';

export const useMutationDeleteCard = () => {
    return useMutation<string, QueryError, { cardId: number; versionId?: number }>(({ cardId, versionId }) =>
        mutationFn({ cardId, versionId }),
    );
};
